/**
 * Action types for client sessions functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle list of captive portals.
 */

// Get captive portals constants
export const CLIENT_SESSIONS_REQUEST_GET = 'CLIENT_SESSIONS_REQUEST_GET';
export const CLIENT_SESSIONS_RESPONSE_GET_SUCCESS = 'CLIENT_SESSIONS_RESPONSE_GET_SUCCESS';
export const CLIENT_SESSIONS_RESPONSE_GET_FAIL = 'CLIENT_SESSIONS_RESPONSE_GET_FAIL'

// Get client session history constants
export const CLIENT_SESSIONS_HISTORY_REQUEST_GET = 'CLIENT_SESSIONS_HISTORY_REQUEST_GET';
export const CLIENT_SESSIONS_HISTORY_RESPONSE_GET_SUCCESS = 'CLIENT_SESSIONS_HISTORY_RESPONSE_GET_SUCCESS';
export const CLIENT_SESSIONS_HISTORY_RESPONSE_GET_FAIL = 'CLIENT_SESSIONS_HISTORY_RESPONSE_GET_FAIL'
export const CLIENT_SESSIONS_HISTORY_RESET = 'CLIENT_SESSIONS_HISTORY_RESET'

export const DISCONNECT_CLIENT_SESSIONS_REQUEST_GET = 'DISCONNECT_CLIENT_SESSIONS_REQUEST_GET';
export const DISCONNECT_CLIENT_SESSIONS_RESPONSE_GET_SUCCESS = 'DISCONNECT_CLIENT_SESSIONS_RESPONSE_GET_SUCCESS';
export const DISCONNECT_CLIENT_SESSIONS_RESPONSE_GET_FAIL = 'DISCONNECT_CLIENT_SESSIONS_RESPONSE_GET_FAIL';